// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IHomeWebpageApiResponse, IHomeWebpage, IHomeWebpageGetAttrs } from 'interfaces/webpage/home'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_baseResponseWebpage } from 'models/extensions/with-helper'

const HomeWebpageStore = types
  .model('HomeWebpage')
  .props({
    homeWebpage_isLoading: types.optional(types.boolean, false),
    homeWebpage_webpage: withHelper_baseResponseWebpage(),
  })
  .actions(self => ({
    homeWebpage_SET_LOADING: (payload: boolean): void => {
      self.homeWebpage_isLoading = payload
    },
    homeWebpage_SET_HOME_WEBPAGE: (payload: IHomeWebpage): void => {
      self.homeWebpage_webpage = cast(payload)
    },
    homeWebpage_CLEAR_HOME_WEBPAGE: (): void => {
      self.homeWebpage_webpage = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch home webpage
     *
     * @return {any} any
     */
    homeWebpage_fetchHomeWebpage: flow(function* (payload: IHomeWebpageGetAttrs) {
      self.homeWebpage_SET_LOADING(true)

      const response: IHomeWebpageApiResponse = yield self.environment.homeWebpageApi.homeWebpage_getHome(payload)
      if (response.ok) self.homeWebpage_SET_HOME_WEBPAGE(response.res.data)

      self.homeWebpage_SET_LOADING(false)
    }),
  }))

export const createHomeWebpageStoreDefaultModel = () => types.optional(HomeWebpageStore, {})
